module.exports = __webpack_public_path__ + "static/media/02-banner-01-polanco-mobile@2x.ee101e10.jpg";